import { RecordingResult } from '../services/recording';

export class RecordingModal {
  public render(container: HTMLElement, result: RecordingResult, roomId: string) {
    // Remove existing modal if any
    const existing = container.querySelector('#recording-modal-overlay');
    if (existing) existing.remove();

    const hrs = Math.floor(result.duration / 3600).toString().padStart(2, '0');
    const mins = Math.floor((result.duration % 3600) / 60).toString().padStart(2, '0');
    const secs = (result.duration % 60).toString().padStart(2, '0');
    const timeFormatted = `${hrs}:${mins}:${secs}`;
    const sizeFormatted = (result.sizeBytes / (1024 * 1024)).toFixed(2) + ' MB';
    const filename = `verve-${roomId}-${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')}.webm`;

    const overlay = document.createElement('div');
    overlay.id = 'recording-modal-overlay';
    overlay.className = 'modal-backdrop';
    overlay.innerHTML = `
      <div class="modal-card" style="max-width: 620px; width: 90%;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.25rem;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <div style="width: 36px; height: 36px; border-radius: 50%; background: rgba(239, 68, 68, 0.15); display: flex; align-items: center; justify-content: center; color: var(--color-danger);">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <circle cx="12" cy="12" r="8"></circle>
              </svg>
            </div>
            <div>
              <h3 style="font-size: 1.2rem; margin: 0;">Meeting Recording Ready</h3>
              <p style="font-size: 0.8rem; color: var(--text-secondary); margin: 0;">Preview and download your high-definition recording</p>
            </div>
          </div>
          <button id="btn-close-rec-modal" style="background: none; border: none; color: var(--text-muted); cursor: pointer; font-size: 1.5rem; line-height: 1;">&times;</button>
        </div>

        <div style="width: 100%; border-radius: var(--radius-md); overflow: hidden; background: #000; margin-bottom: 1.25rem;">
          <video src="${result.url}" controls playsinline style="width: 100%; max-height: 320px; display: block; object-fit: contain;"></video>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 1.5rem;">
          <div style="background: var(--bg-surface-elevated); padding: 10px 14px; border-radius: var(--radius-md); border: 1px solid var(--border-subtle);">
            <div style="font-size: 0.75rem; color: var(--text-muted);">Duration</div>
            <div style="font-size: 1.1rem; font-weight: 700; font-family: var(--font-mono);">${timeFormatted}</div>
          </div>
          <div style="background: var(--bg-surface-elevated); padding: 10px 14px; border-radius: var(--radius-md); border: 1px solid var(--border-subtle);">
            <div style="font-size: 0.75rem; color: var(--text-muted);">File Size</div>
            <div style="font-size: 1.1rem; font-weight: 700; font-family: var(--font-mono);">${sizeFormatted}</div>
          </div>
        </div>

        <div style="display: flex; gap: 12px; justify-content: flex-end; align-items: center;">
          <button id="btn-dismiss-rec" class="btn-secondary">Close</button>
          <a id="btn-download-rec" href="${result.url}" download="${filename}" class="btn-primary" style="width: auto; text-decoration: none; padding: 10px 20px; display: inline-flex; align-items: center; gap: 8px;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
            <span id="btn-download-rec-text">Save Recording (.webm)</span>
          </a>
        </div>
      </div>
    `;

    container.appendChild(overlay);

    const close = () => {
      overlay.remove();
    };

    const dlBtn = overlay.querySelector('#btn-download-rec') as HTMLAnchorElement;
    const dlText = overlay.querySelector('#btn-download-rec-text') as HTMLElement;
    if (dlBtn) {
      dlBtn.addEventListener('click', () => {
        if (dlText) dlText.textContent = '✅ Saved to Downloads!';
        setTimeout(close, 1500);
      });
    }

    overlay.querySelector('#btn-close-rec-modal')?.addEventListener('click', close);
    overlay.querySelector('#btn-dismiss-rec')?.addEventListener('click', close);
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });
  }
}
